module.exports = __webpack_public_path__ + "static/media/benefit-ic.0f4c4aca.png";